"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveUserAggDataViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveUserAggDataViewModel = function () {
        function FourFiveUserAggDataViewModel(fourFiveUserAggData) {
            _classCallCheck(this, FourFiveUserAggDataViewModel);

            this.firstLoginDate = ko.observable('');
            this.lastLoginDate = ko.observable('');
            this.update(fourFiveUserAggData);
        }

        _createClass(FourFiveUserAggDataViewModel, [{
            key: "update",
            value: function update(fourFiveUserAggData) {
                this.firstLoginDate(fourFiveUserAggData.firstLoginDate ? moment(fourFiveUserAggData.firstLoginDate).format('DD/MM/YYYY HH:mm:ss') : '');
                this.lastLoginDate(fourFiveUserAggData.lastLoginDate ? moment(fourFiveUserAggData.lastLoginDate).format('DD/MM/YYYY HH:mm:ss') : '');
            }
        }, {
            key: "clear",
            value: function clear() {
                this.firstLoginDate('');
                this.lastLoginDate('');
            }
        }]);

        return FourFiveUserAggDataViewModel;
    }();

    return FourFiveUserAggDataViewModel;
});
//# sourceMappingURL=fourFiveUserAggDataViewModel.js.map;
